import axios, { defaultParams } from './axios';
export default function deleteRequest(url, data, config) {
    const merged = {
        ...defaultParams(),
        ...(config ?? {}),
    };
    if (data !== undefined) {
        merged.data = data;
    }
    return axios.delete(url, merged);
}
